import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let pipestatusExample = `false | true
echo $?              # 0 - only the last command's status

false | true
echo "$\{PIPESTATUS[@]}"   # 1 0 - status of every stage`

let strictModeExample = `#!/usr/bin/env bash
set -euo pipefail

# -e: exit immediately if any command fails
# -u: error on use of an unset variable
# -o pipefail: a pipeline fails if ANY stage fails, not just the last

process_file "$1"`

export default function PipelinesAndExitStatus() {
    return (
        <div className={globalStyles.article}>
            <h1>Pipelines & exit status</h1>

            <h3>$?</h3>
            <p>Every command sets <code>$?</code> to its exit status (0 = success, 1-255 = failure) as soon as
                it finishes. Check it immediately — the next command overwrites it.</p>
            <pre className={globalStyles.code}>
                <code>
                    grep "ERROR" app.log<br/>
                    if [ $? -eq 0 ]; then echo "found errors"; fi<br/>
                    <br/>
                    <span style={{opacity: 0.7}}># Idiomatic version — skip $? entirely</span><br/>
                    if grep -q "ERROR" app.log; then echo "found errors"; fi
                </code>
            </pre>

            <h3>Pipelines only report the last command by default</h3>
            <p><code>$?</code> after a pipeline reflects only its final stage. Use <code>PIPESTATUS</code>
                (bash-specific) to inspect every stage.</p>
            <SyntaxHighlighter
                children={pipestatusExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>set -e -u -o pipefail</h3>
            <p>The standard "strict mode" preamble for scripts — makes failures loud instead of silently
                continuing.</p>
            <SyntaxHighlighter
                children={strictModeExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Short-circuiting with && / ||</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '400px'}}>
                    <thead>
                    <tr>
                        <th>Syntax</th>
                        <th>Runs the right-hand side when...</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>cmd1 &amp;&amp; cmd2</code></td>
                        <td><code>cmd1</code> succeeds (exit 0)</td>
                    </tr>
                    <tr>
                        <td><code>cmd1 || cmd2</code></td>
                        <td><code>cmd1</code> fails (non-zero exit)</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
